<template>
  <div class="film-action-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" label-width="100px">
        <el-form-item label="番号:" prop>
          <el-input size="small" placeholder="请输入番号" v-model="params.number"></el-input>
        </el-form-item>
        <el-form-item label="标题:" prop>
          <el-input size="small" placeholder="请输入标题" v-model="params.number"></el-input>
        </el-form-item>
        <div class="label-box">
          <el-form-item label="标签:" prop>
            <el-input size="small" placeholder="请输入或选择标签" v-model="params.number"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              style="margin-left: -90px"
              v-model="params.number"
            >新增</el-button>
          </el-form-item>
        </div>
        <div class="label-box">
          <el-form-item label="演员:" prop>
            <el-input size="small" placeholder="请输入或选择演员" v-model="params.number"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              style="margin-left: -90px"
              v-model="params.number"
            >新增</el-button>
          </el-form-item>
        </div>
        <div class="label-box">
          <el-form-item label="频道:" prop="platform">
            <el-select
              size="small"
              placeholder="请选择频道"
              style="width: 250px"
              v-model="params.number"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in channelSelection"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" style="margin-left: -90px">新增</el-button>
          </el-form-item>
        </div>
        <div class="label-box">
          <el-form-item label="条件:" prop="platform">
            <el-select
              size="small"
              placeholder="请选择条件"
              style="width: 250px"
              v-model="params.number"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in conditionalSelection"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" style="margin-left: -90px">新增</el-button>
          </el-form-item>
        </div>
        <div class="label-box">
          <el-form-item label="价值:" prop>
            <el-input size="small" style="width: 75px" v-model="params.number"></el-input>
          </el-form-item>
          <el-form-item label="免费时长:" prop>
            <el-input size="small" style="width: 75px" v-model="params.number"></el-input>
          </el-form-item>
        </div>
        <div class="label-box">
          <el-form-item label="评分:" prop>
            <el-input size="small" style="width: 75px" v-model="params.number"></el-input>
          </el-form-item>
          <el-form-item label="指数:" prop>
            <el-input size="small" style="width: 75px" v-model="params.number"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="播放:" prop>
          <el-input size="small" placeholder="请输入播放" v-model="params.number"></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-radio-group>
            <el-radio
              v-for="item in statusType"
              :label="item.value"
              :key="item.label"
            >{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      dialogVisible: false,
      flag: false,
      // 频道选择
      channelSelection: [
        {
          label: "日本",
          value: 1,
        },
        {
          label: "欧美",
          value: 2,
        },
        {
          label: "动漫",
          value: 3,
        },
        {
          label: "金币专区",
          value: 4,
        },
        {
          label: "麻豆传媒",
          value: 5,
        },
      ],
      // 条件选择
      conditionalSelection: [
        {
          label: "VIP",
          value: 1,
        },
        {
          label: "免费",
          value: 2,
        },
        {
          label: "付费",
          value: 3,
        },
        {
          label: "限免",
          value: 4,
        },
      ],
      statusType: [
        {
          label: "已上架",
          value: 1,
        },
        {
          label: "未上架",
          value: 2,
        },
        {
          label: "已下架",
          value: 3,
        },
      ],
      params: {
        number: 0,
      },
    };
  },
  methods: {
    // 关闭弹窗时
    handleClose() {
      this.dialogVisible = false;
    },
    // eslint-disable-next-line no-unused-vars
    open(type, data) {
      this.dialogVisible = true;
      if (type === "edit") {
        this.title = "编辑影片";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.el-input {
  width: 250px;
}
.label-box {
  display: flex;
  justify-content: flex-start;
}
</style>